<template>

    <div class="h-full w-full mx-auto bg-body overflow-hidden flex fixed top-0 left-0" >
        <!-- SIDEBAR / FILTROS-->
        <div class="w-1/6 flex-none h-full py-2 pl-2 pr-1 flex flex-col">
            <div class="bg-module rounded shadow-3xl  border-t-4 border-aux max-h-full overflow-hidden flex flex-col">
                <div class="p-2 text-aux text-xl">Familias</div>


                <div class="text-white flex flex-col h-full overflow-hidden">
                    <vue-scroll>
                        <All model="stock/Categories"  :immediate="true" v-slot="{data,loading}">
                            <div>
                                <div class="flex px-2 hover:bg-aux-60" @click.prevent="selectCat(false)"  :class="{'bg-aux-30':selectedCat == false}">
                                    TODAS
                                </div>
                                <template v-for="cat in stock_categories">
                                    <div class="flex px-2  hover:bg-aux-60 ellipsis" 
                                         @click.prevent="selectCat(cat)" 
                                         :class="{'bg-aux-30':selectedCat == cat.id}">
                                        <div class="mr-auto">{{cat.name}}</div>
                                    </div>
                                </template>
                            </div>
                        </All>
                    </vue-scroll>
                </div>
            </div>
            <div class="bg-module rounded shadow-3xl  border-t-4 border-aux mt-2">
                <div class="p-2 text-aux text-xl">Ordenar por</div>
                <div class="text-white flex flex-col">
                    <div class="" v-for="el in sort">
                        <div class="flex pl-2  hover:bg-aux-60 " @click.prevent="selectSort(el)"  :class="{'bg-aux-30':selectedSort == el.value}">
                            {{el.name}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="bg-module rounded shadow-3xl  border-t-4 border-aux mt-2" v-if="selectedSort == 'sales'">
                <div class="p-2 text-aux text-xl">Rango de fecha</div>
                <div class="text-white flex flex-col">
                    <div class="" v-for="el in range">
                        <div class="flex pl-2  hover:bg-aux-60 " @click.prevent="selectRange(el)"  :class="{'bg-aux-30':selectedRange == el.value}">
                            {{el.name}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="bg-module rounded shadow-3xl  border-t-4 border-aux mt-2">
                <div class="p-2 text-aux text-xl">Buscar</div>
                <div class="text-white flex flex-col">
                    <div class="flex p-2">
                        <input class="flex-1 overflow-hidden rounded-l text-font-dark px-1" 
                               v-model="stringModel"
                               @keyup.enter="setStringFilter(stringModel)">
                        <button type="submit" class="font-semibold  leading-none py-1 text-center w-16 border-t border-b border-l hover:bg-aux-30 bg-transparent border-aux text-aux"
                                @click="setStringFilter(stringModel)">
                            <i class="mdi mdi-magnify"></i>
                        </button>
                        <button 
                                class="font-semibold  leading-none py-1 text-center w-16 border rounded-r hover:bg-aux-30 bg-transparent border-aux text-aux"
                                @click.prevent="setStringFilter(false)">
                            <i class="mdi mdi-close"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="bg-module rounded shadow-3xl  border-t-4 border-aux mt-2">
                <div class="p-2 text-aux text-xl">Ocultos</div>
                <div class="text-white flex items-center p-2">
                    <div class="flex-1 overflow-hidden">Ver ocultos</div>
                    <button 
                            class="font-semibold  leading-none py-1 text-center w-16 border rounded hover:bg-aux-30"
                            :class="showHidden ? 'border-transparent text-module bg-aux' : 'bg-transparent border-aux text-aux'"
                            @click.prevent="toggleHidden()">
                        <template  v-if="showHidden">ON</template>
                        <template v-else>OFF</template>
                    </button>

                </div>
            </div>
        </div>       

        <div class="flex-1 flex overflow-hidden relative">
            <!-- EXCESOS -->
            <div class="flex-1 overflow-hidden py-2 px-1 flex flex-col">
                <div class="bg-module rounded-t border-t-4 text-xl border-success text-success p-2 mb-1">
                    {{ selectedSort === 'optime' ?   'Excesos' : 'Más vendidos'}}
                </div> 
                <div class="bg-module flex-1 overflow-hidden rounded-b relative text-white">

                    <Paginate  @success="getLastPage" 
                              propKey="products" 
                              :replace="false"  
                              :key="'excesses'+paginateKey"
                              :page="excessesPage" 
                              model="stock/Products"  
                              ref="excesses"   
                              :query="paramsExcesses" 
                              :immediate="true" 
                              v-slot="{data,loading,reset}">

                        <div class="h-full overflow-hidden">

                            <div class="z-10 text-3xl absolute h-full w-full top-0 left-0 bg-box-30 flex items-center justify-center" v-if="loading">
                                <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                            </div>
                            <vue-scroll ref="excessesScroll">
                                <div class="text-white p-2" v-if="true">


                                    <product-summary 
                                                     :key="'excesses-'+product.id "
                                                     :class="{'bg-aux-10 border-aux-60':currentProduct == product.id}"
                                                     @updateProductList="updateProductList('excesses')" 
                                                     :modalPosition="'right'" 
                                                     @setModalPosition="setModalPosition"
                                                     :product="product"  
                                                     v-for="(product,ind) in data" />

                                    <template v-if="!loading">
                                        <div v-if="!lastExcessesPage && excessesFirstLoad" 
                                             v-observe-visibility="{
                                                                   callback: addPage,
                                                                   throttle: false
                                                                   }">
                                            <div class="text-2xl bg-module  p-2 text-aux text-center cursor-pointer" @click="addPage">Cargar más</div>
                                        </div>
                                        <div  v-else class="p-2 bg-aux mb-2 text-black">
                                            No hay mas productos
                                        </div>
                                    </template>
                                </div>
                            </vue-scroll>

                        </div>
                    </Paginate>



                </div>

                <div  class="flex justify-around text-aux" v-if="false">
                    <div class="p-2 flex items-center" :class="excessesPage == 1 ? 'text-aux-30': 'cursor-pointer'" @click="excessesPage == 1 ? excessesPage : excessesPage--">
                        <i class="mdi mdi-skip-previous leading-none text-2xl"></i> Cargar anteriores
                    </div>
                    <div class="p-2 text-center">
                        Página {{excessesPage}}
                    </div>
                    <div class="p-2 flex items-center" :class="lastExcessesPage ? 'text-aux-30': 'cursor-pointer'" @click="excessesPage == lastExcessesPage ? excessesPage : excessesPage++">
                        Cargar siguientes <i class="mdi mdi-skip-next leading-none text-2xl"></i>
                    </div>
                </div>
            </div> 
            <!-- FALTAS -->
            <div class="flex-1 overflow-hidden py-2 px-1 flex flex-col">
                <div class="bg-module rounded-t border-t-4 text-xl border-danger text-danger p-2 mb-1">

                    {{ selectedSort === 'optime' ?   'Faltas' : 'Menos vendidos'}}
                </div>
                <div class="bg-module flex-1 overflow-hidden rounded-b relative">
                    <Paginate  @success="getLastFaultsPage" 
                              propKey="products" 
                              :replace="false"  
                              :key="'faults'+paginateKey"
                              :page="faultsPage" 
                              model="stock/Products"  
                              ref="faults"   
                              :query="paramsFaults"
                              :immediate="true" 
                              v-slot="{data,loading,reset}">
                        <div class="h-full overflow-hidden">
                            <div class="z-10 text-3xl absolute h-full w-full top-0 left-0 bg-box-30 flex items-center justify-center" v-if="loading">
                                <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                            </div>
                            <vue-scroll ref="faultsScroll">

                                <div class="text-white p-2">
                                    <product-summary 
                                                     :key="'faults-'+product.id"
                                                     :class="{'bg-aux-10 border-aux-60':currentProduct == product.id}"
                                                     :modalPosition="'left'" 
                                                     @updateProductList="updateProductList('faults')" 
                                                     @setModalPosition="setModalPosition"
                                                     :product="product" 
                                                     v-for="(product,ind) in data" />
                                    <template v-if="!loading">
                                        <div v-if="!lastFaultsPage && faultsFirstLoad" 
                                             v-observe-visibility="{
                                                                   callback: addFaultsPage,
                                                                   throttle: false,
                                                                   }">
                                            <div class="text-2xl bg-module  p-2 text-aux text-center cursor-pointer" @click="addPage">Cargar más</div>
                                        </div>
                                        <div  v-else class="p-2 bg-aux mb-2 text-black">
                                            No hay mas productos
                                        </div>
                                    </template>
                                </div>
                            </vue-scroll>

                        </div>
                    </Paginate>
                </div>
            </div>
            <div class="hidden right-0 left-0"></div>
            <div class="absolute py-2 px-1 top-0 h-full w-1/2   text-font  overflow-hidden" :class="modalPosition+'-0'" v-if="currentProduct && modalPosition">
                <div class="bg-box h-full rounded shadow text-white p-2 overflow-hidden">
                    <All model="stock/SingleProducts"   @success="setInitialPeriodStock" :ref="'single_produt'" :query="{id:currentProduct}"  :immediate="true" v-slot="{data,loading}">

                        <div class="w-full h-full overflow-hidden flex flex-col" v-if="(!loading && data.data && data.data.product)">
                            <div class="flex justify-end">
                                <Request model="stock/SetPeriodStock" @success="updateProduct(data.data.product.id)" action="update" :form="{id:data.data.product.id,period_stock:periodStock}"  v-slot="{request,loading}">
                                    <div class="flex transition-all duration-300 ease-in-out justify-end overflow-hidden" :class="editTime ? ' w-32' : ' w-0 ' ">

                                        <input class="flex-none w-12 overflow-hidden rounded mr-1 text-font-dark px-1" name="" v-model="periodStock = data.data.product.period_stock">
                                        <button class="flex-none w-12 font-semibold  leading-none py-1 text-center  border rounded hover:bg-aux-30 bg-transparent border-aux text-aux"  @click="request">
                                            <i class="mdi mdi-content-save"></i>
                                        </button>
                                    </div>
                                </Request>
                                <div class="h-6 w-6 flex-none rounded-full flex items-center justify-center bg-aux-30 hover:bg-aux-60 text-aux hover:text-white ml-2">
                                    <i class="mdi mdi-calendar-month" @click="editTime = !editTime "></i>
                                </div>

                                <Request model="stock/SetToggleHide" @success="updateProductList()" action="update" :form="{id:data.data.product.id}"  v-slot="{request,loading}">
                                    <div class="h-6 w-6 flex-none rounded-full flex items-center justify-center bg-aux-30 hover:bg-aux-60 text-aux hover:text-white ml-2"
                                         @click="request">
                                        <i class="mdi mdi-eye-off-outline" v-if="data.data.product.is_hidden"></i>
                                        <i class="mdi mdi-eye-outline" v-else></i>
                                    </div>
                                </Request>
                                <div class="h-6 w-6 flex-none rounded-full flex items-center justify-center bg-aux-30 hover:bg-aux-60 text-aux hover:text-white ml-2">
                                    <i class="mdi mdi-close" @click="openProduct(false)"></i>
                                </div>
                            </div>

                            <div class="flex-none flex h-44">
                                <div class="flex-none w-44 bg-cover bg-center rounded sadow"
                                     v-if="data.data.product.image"
                                     :style="'background-image:url('+data.data.product.image+')'">
                                </div>
                                <div class="flex-none w-44 bg-cover bg-center rounded sadow"
                                     v-else
                                     style="background-image:url('images/logotipo-la-tienda-de-valentina.jpg')" 
                                     >
                                </div>
                                <div class="w-full overflow-hidden px-2 flex flex-col">
                                    <div class="flex items-center justify-between">
                                        <div class="text-4xl ellipsis">{{data.data.product.name}}</div>
                                        <div class="text-3xl text-aux font-bold">{{data.data.product.price  | numberFormat(2)}}<small class="text-aux-60">€</small>
                                        </div>
                                    </div>

                                    <div>
                                        Total stock: {{data.data.product.stock.current}} / {{data.data.product.stock.total}} 
                                    </div>
                                    <div>
                                        Total ventas: {{data.data.product.sales_amount  | numberFormat(2)}}<small>€</small>
                                    </div>
                                    <div class="flex-1 overflow-hidden flex">
                                        <div v-for="variation in data.data.product.variants" class="mr-1  flex flex-col w-12">
                                            <div class="w-full flex bg-module items-center justify-center h-full rounded overflow-hidden"
                                                 :class="'stock-'+variation.stock_class">
                                                {{variation.stock}}
                                            </div>
                                            <small class="w-full flex items-center justify-center leading-none pt-1" v-if="variation.name !== 'Default Title'">
                                                {{variation.name}} 
                                            </small>

                                        </div>

                                    </div>
                                </div>
                            </div>
                            <vue-scroll>
                                <div class="bg-box-30 p-2 rounded my-2">
                                    <div class="text-sm text-font-gray">Evolución stock</div>
                                    <div class="p-2 h-48">
                                        <chart-stock-evolution :data="data.data.product.evolution" chartId="evolution"/>
                                    </div>
                                </div>
                                <div class="bg-box-30 p-2 rounded my-2">
                                    <div class="text-sm text-font-gray">Velocidad de venta</div>
                                    <div class="p-2 h-48">
                                        <chart-stock-sales-speed 
                                                                 :data="data.data.product.sales_speed"  
                                                                 :daysEstimated="data.data.product.days_estimated" 
                                                                 :periodStock="data.data.product.period_stock" 
                                                                 chartId="speed"/>
                                    </div>
                                </div>
                                <div class="flex py-2 my-2  border-module">
                                    <div class="flex-1 text-center ">
                                        <div class="text-xs text-font-gray">Uds. Vendidas </div>
                                        <div class="text-xl">{{data.data.product.sales_quantity}}
                                            <small class="text-font-gray">(stock <span class="text-white" >{{data.data.product.stock.current}}</span>)</small>
                                        </div>
                                    </div>
                                    <div class="flex-1 text-center border-l border-module ">
                                        <div class="text-xs text-font-gray">Uds. venta día</div>
                                        <div class="text-xl">{{data.data.product.avg_per_day}}</div>
                                    </div>
                                    <div class="flex-1 text-center border-l border-module ">
                                        <div class="text-xs text-font-gray">Márgen</div>
                                        <div class="text-xl">{{data.data.product.margin_days | numberFormat(0)}}</div>
                                    </div>
                                    <div class="flex-1 text-center border-l border-module " v-if="data.data.product.sales_amount_out_stock < 0">
                                        <div class="text-xs text-font-gray">Ventas perdidas</div>
                                        <div class="text-xl text-danger">{{data.data.product.sales_amount_out_stock |numberFormat(2)}}<small>€</small></div>
                                    </div>
                                </div>
                                <div class="flex">
                                    <div class="flex-none w-34">
                                        <div class="p-2 text-xs text-transparent">Nombre </div>
                                        <div class="p-2">Stock</div>
                                        <div class="p-2">Ventas/día</div>
                                                
                                        <div class="p-2 h-14 flex items-center"> Ratio de venta</div>
                                        <div class="p-2">Uds venta al día</div>
                                        <div class="p-2">Dias margen</div>
                                        <div class="p-2 h-16 flex items-center">
                                            <div> Dias para fin
                                                <div class="text-xs text-font-gray">{{data.data.product.period_stock_start}}</div>
                                                <div class="text-xs text-font-gray">{{data.data.product.period_stock_end}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-for="variation in data.data.product.variants" class="overflow-hidden odd:bg-module-30 w-20 border-l border-module  text-center">

                                        <div class="p-2  text-xs">{{variation.name}}</div>
                                        <div class="p-2 font-bold rounded mx-2" :class="'stock-'+variation.stock_class">{{variation.stock}}</div>
                                        <div class="p-2">{{variation.sales_quantity}}</div>
                                        <div class="p-2 text-font-aux h-14 flex items-center leading-none justify-center">
                                            <div class="">
                                                <span class="text-xl"> {{variation.ratio}} </span><br>
                                                <small class="text-success">{{variation.ratio_percent}}<small>%</small></small>
                                            </div>
                                        </div>
                                        <div class="p-2">{{variation.avg_sales}}</div>
                                        <div class="p-2">{{variation.margin_days | numberFormat(0)}}D</div>
                                        <div class="p-2 h-16 flex items-center justify-center">{{variation.days_out_stock}}</div>
                                        <div class="p-2 bg-warning text-module ">{{variation.sales_out_stock}}</div>
                                    </div>
                                </div>
                            </vue-scroll>
                        </div>
                        <div v-else>
                            <div class="h-6 w-6 flex-none rounded-full flex items-center justify-center bg-aux-30 hover:bg-aux-60 text-aux hover:text-white ml-2">
                                <i class="mdi mdi-close" @click="openProduct(false)"></i>
                            </div>
                        </div>
                    </All>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import Model from "@/api/Model";
    import chartStockDonnut from '@/components/chartStockDonnut.vue';
    import chartStockEvolution from '@/components/chartStockEvolution.vue';
    import chartStockSalesSpeed from '@/components/chartStockSalesSpeed.vue';
    import ProductSummary from '@/components/stock/ProductSummary.vue';

    import { state,actions } from '@/store';
    import { All,Request,Paginate } from '@/api/components';


    let sort =[
        {
            name: 'Faltas y excesos',
            value: 'optime'
        },
        {
            name: 'Scoring',
            value: 'scoring'
        },
        {
            name: 'Ventas',
            value: 'sales'
        }
    ]
    let range = [
        {
            name: 'Ayer',
            value: 'yesterday'
        },
        {
            name: 'Últimos 7 días',
            value: 'last7days'
        },
        {
            name: 'Últimos 30 días',
            value: 'last30days'
        },
    ]
    export default {
        name: 'Stock',
        components:{
            chartStockDonnut,
            chartStockEvolution,
            chartStockSalesSpeed,
            All,
            Request,
            Paginate,
            ProductSummary
        },
        data(){
            return {
                selectedCat:false,
                selectedSubCat:false,
                selectedSort:'optime',
                selectedRange:'yesterday',
                searchString:'',
                stringModel:'',
                showHidden:false,
                putToggle:false,
                modalPosition:false,
                periodStock:0,
                editTime:false,
                excessesFirstLoad:false,
                excessesPage:1,
                excessesScrollPossition:0,
                resetExcesses:false,
                lastExcessesPage:false,
                faultsFirstLoad:false,
                faultsPage:1,
                faultsScrollPossition:0,
                lastFaultsPage:false,
                postsPerPage:20,
                busy:false,
            }  
        },
        computed: {
            paginateKey(){
                let hidden = this.showHidden ? 'hidden' : 'visible'
                return this.selectedCat+''+this.selectedRange+''+this.selectedSort+''+this.searchString+''+hidden
            },
            commonParams(){
                let params
                if(this.selectedCat){
                    params = {...params, ...{category:this.selectedCat}}    
                }
                params = {...params, ...{show_hidden:this.showHidden ? 1 : 0}}
                if(this.searchString){
                    params = {...params, ...{search:this.searchString}} 
                }
                params = {...params, ...{period:this.selectedRange}}
                params = {...params, ...{per_page:this.postsPerPage}}
                return params
            },

            paramsExcesses(){
                let params = {}
                if(this.selectedSort === 'optime'){
                    params = {...params, ...{sort:'excesses'}}
                } else if(this.selectedSort === 'scoring'){
                    params = {...params, ...{sort:'more_scoring'}}
                } else {
                    params = {...params, ...{sort:'more_sold'}}
                }
                params = {...params, ...this.commonParams}

                return params
            },

            paramsFaults(){
                let params = {}
                if(this.selectedSort === 'optime'){
                    params = {...params, ...{sort:'faults'}}
                } else if(this.selectedSort === 'scoring'){
                    params = {...params, ...{sort:'less_scoring'}}
                } else {
                    params = {...params, ...{sort:'less_sold'}}
                }
                params = {...params, ...this.commonParams}


                return params
            },

            stock_categories() {
                return state.stock_categories
            },
            sort(){
                return sort
            },
            range(){
                return range
            },

            showMenu(){
                return state.showMenu
            },
            currentProduct(){
                return state.currentProduct
            },

        },
        methods:{
            setStringFilter(stringModel) {

                if (stringModel) {
                    this.searchString = stringModel
                } else {
                    this.searchString = ''
                    this.stringModel = ''
                }
            },
            getLastPage(data){
                setTimeout( () => {
                    this.excessesFirstLoad = true
                    this.$refs["excessesScroll"].scrollTo(
                        {
                            y:  this.excessesScrollPossition.scrollTop
                        },
                        1
                    );
                },1)
                if(data.cont % this.postsPerPage !== 0 || data.cont === 0) {
                    this.lastExcessesPage = this.excessesPage
                } else {
                    this.lastExcessesPage = false    
                }

            },
            getLastFaultsPage(data){
                setTimeout( () => {
                    this.faultsFirstLoad = true
                    this.$refs["faultsScroll"].scrollTo(
                        {
                            y:  this.faultsScrollPossition.scrollTop
                        },
                        1
                    );
                },1)
                if(data.cont % this.postsPerPage !== 0 || data.cont === 0) {
                    this.lastFaultsPage = this.faultsPage
                } else {
                    this.lastFaultsPage = false    
                }

            },
            addPage(isVisible, entry){
                //console.log('VISIBLE-->',isVisible, entry)
                if(isVisible) {
                    this.excessesScrollPossition = this.$refs["excessesScroll"].getPosition()
                    this.excessesPage++
                }
            },
            addFaultsPage(isVisible, entry){
                if(isVisible) {
                    this.faultsScrollPossition = this.$refs["faultsScroll"].getPosition()
                    this.faultsPage++
                }
            },
            setInitialPeriodStock(val){


            },
            updateProductList(position){
                if(position) {
                    this.$refs[position].request()    
                    this.$refs.single_produt.request()  
                } else {
                    this.$refs.single_produt.request()  
                    this.$refs.excesses.request()    
                    this.$refs.faults.request()    
                }
            },

            updateProduct(id){
                this.editTime = false
                // this.$refs.single_produt.request()    
            },
            openProduct(id){
                actions.openProduct(id)
                if(id === false ){
                    this.setModalPosition(id)
                }
            },
            selectCat(cat)  {
                this.setFirstPage()
                //this.resetExcesses= !this.resetExcesses
                this.selectedCat = (cat.id) ? cat.id : false
                this.selectSubCat(cat)
            },
            selectSubCat(cat)  {


                this.selectedSubCat = (cat.name) ? cat.name : false
            },
            selectSort(sort){
                this.setFirstPage()
                //this.resetExcesses= !this.resetExcesses
                this.selectedSort = (sort.value) ? sort.value : false
            },
            selectRange(range){
                this.setFirstPage()
                //this.resetExcesses= !this.resetExcesses
                this.selectedRange = (range.value) ? range.value : false
            },
            setModalPosition(pos){
                this.modalPosition = pos
            },
            toggleHidden(){
                this.setFirstPage()
                this.showHidden = !this.showHidden
            },
            setFirstPage(){
                console.log('setFirstPage',this.excessesPage)
                this.excessesPage=1
                this.lastExcessesPage=false
                this.faultsPage=1
                this.lastFaultsPage=false
                this.openProduct(false)
            }
        },
        watch:{
            showMenu(n,o){

            },
            searchString(n,o){
                this.setFirstPage()
            }
        }
    }
</script>
<style lang="scss">
    /*  $viewPort:1920;*/
    /*  $fontSizeBase:16;*/
    html{
        font-size: 0.833333333333vw;
        body {
            overflow: hidden;
        }
    }


    .stock-light {
        background-color: cyan;
        color: #161C20;
    }
    .stock-medium {
        background-color: #068e85;
        color: #161C20;
    }
    .stock-dark {
        background-color: #173e3d;
        color: #4AF1B1;
    }
    .ellipsis{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .lds-ring {
        display: inline-block;
        position: relative;
        width: 5rem;
        height: 5rem;
    }
    .lds-ring div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 4rem;
        height: 4rem;
        margin: .5rem;
        border: .5rem solid #4AF1B1;
        border-radius: 50%;
        animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: #4AF1B1 transparent transparent transparent;
    }
    .lds-ring div:nth-child(1) {
        animation-delay: -0.45s;
    }
    .lds-ring div:nth-child(2) {
        animation-delay: -0.3s;
    }
    .lds-ring div:nth-child(3) {
        animation-delay: -0.15s;
    }
    @keyframes lds-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

</style>
